import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: `${theme.palette.background.default} !important`,
    marginTop: -22,
    marginLeft: -96,
    marginRight: -96,
    marginBottom: 56,
    [theme.breakpoints.down('sm')]: {
      marginRight: -14,
      marginLeft: -15
    }
  },
  appBar: {
    backgroundColor: `${theme.palette.background.default} !important`
  },
  contentContainer: {
    paddingRight: 96,
    paddingLeft: 96,
    paddingTop: 24,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0
    }
  }
}))
export default useStyles
